module.exports = __webpack_public_path__ + "img/2.56276d96.png";